import produce from "immer";

const INITIAL_STATE = [];

const Cart = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "ADD_PRODUCT":
      return produce(state, (draft) => {
        for (let i = 0; i < draft.length; i++) {
          if (draft[i].id === action.product.id) {
            if (
              draft[i].quantity + draft[i].count_step >
              action.product.purchasable_count
            ) {
              return;
            }
            draft[i].quantity += draft[i].count_step;

            return;
          }
        }
        draft.push({
          ...action.product,
          quantity: action.product.count_step,
        });
      });

    case "DELIVERY_OPTIONS":
      let index = 0;
      for (let prod of state) {
        if (action.id === prod.id) {
          if (
            action.address_id === null &&
            action.delivery_date === null &&
            action.delivery_shift === null &&
            action.service_center_id === null &&
            action.delivery_shift_name === null &&
            action.service_center_name === null &&
            action.address === null
          ) {
            state[index] = {
              ...state[index],
              type: action.item_type,
              address_id: null,
              delivery_date: null,
              delivery_shift: null,
              service_center_id: null,
              delivery_shift_name: null,
              service_center_name: null,
              address: null,
            };
            return state;
          }
          state[index] = {
            ...state[index],
            type: action.item_type ?? state[index].item_type,
            address_id: action.address_id ?? state[index].address_id,
            delivery_date: action.delivery_date ?? state[index].delivery_date,
            delivery_shift:
              action.delivery_shift ?? state[index].delivery_shift,
            service_center_id:
              action.service_center_id ?? state[index].service_center_id,
            delivery_shift_name:
              action.delivery_shift_name ?? state[index].delivery_shift_name,
            service_center_name:
              action.service_center_name ?? state[index].service_center_name,
            address: action.address ?? state[index].address,
          };
          return state;
        }
        index++;
      }
      return state;

    case "REMOVE_PRODUCT":
      return action.product;

    case "CLEAN_CART":
      return [];

    case "UPDATE_CART":
      return action.cart;

    case "SET_CARTS":
      return [...action.payload];

    case "DECREASE_PRODUCT":
      return produce(state, (draft) => {
        for (let i = 0; i < draft.length; i++) {
          if (draft[i].id === action.product_id) {
            draft[i].quantity -= draft[i].count_step;
            return;
          }
        }
      });

    default:
      return state;
  }
};
export default Cart;
